import { useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { useFormikContext } from 'formik'
import { SelectImageButtonType } from './Types'
import { ImageMenuModal } from 'components/ImageMenu/ImageMenuModal/ImageMenuModal'
import { ACCEPTED_IMAGE_MIME_TYPES_NO_SVG } from 'screens/Finder/components/views/GalleryView/constants'

export const SelectImageButtonDesktop = ({
  onAdd,
  initialQuery,
  showAiConfirm = true,
  label,
  brandKitId,
  ...props
}: SelectImageButtonType) => {
  const { openModal, closeStack } = useModals()
  const { isSubmitting } = useFormikContext()

  const handlePress = () => {
    openModal(
      ImageMenuModal,
      {
        onPressOutside: closeStack,
        accept: ACCEPTED_IMAGE_MIME_TYPES_NO_SVG,
        hiddenProviders: ['gifs', 'stockVideo'],
        onUse: onAdd,
        maxCount: 1,
        title: 'Select an image',
        initialQuery,
        initialBrandKitId: brandKitId,
      },
      { newStack: true },
    )
  }

  return (
    <Button isDisabled={isSubmitting} variant="secondary" onPress={handlePress} {...props}>
      {label}
    </Button>
  )
}
